import { AppInsightsContext } from "@microsoft/applicationinsights-react-js";
import { reactPlugin } from './ApplicationInsightsService';
import PopupForm, { ClosedBy, HidePopup, PopupFormProps, ShowPopup } from './popup-form/popup-form';
import MessageBox, { MessageBoxProps, ShowMessageBox } from "./message-box/message-box";
import './css/App.css';
import './css/button.css';
import logo from './images/TritonAppworks.blue.png';
import emailGlyph from './images/fluent-mail-20-regular.png';

function App() {
  const showPageOverlay = () => {
    const pageOverlay = document.getElementById("pageOverlay")
    if (pageOverlay) {
      pageOverlay.classList.add("overlay-raised");
    }
  }
  const hidePageOverlay = () => {
    const pageOverlay = document.getElementById("pageOverlay")
    if (pageOverlay) {
      pageOverlay.classList.remove("overlay-raised");
    }
  }
  const appsClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
  };
  const utilitiesClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
  };
  const contactClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    showPageOverlay();
    ShowPopup();
  };

  const popupProps: PopupFormProps = {
    onClose: (closedBy: ClosedBy) => {
      HidePopup();

      if (closedBy === ClosedBy.SendButton) {
        ShowMessageBox();
      } else {
        hidePageOverlay();
      }
    }
  };

  const messageBoxProps: MessageBoxProps = {
    content: "Thanks for contacting us! Your message has been submitted.",
    onClose: () => {
      hidePageOverlay();
    }
  };

  return (
    <div className="App">
      <div className="homepage fade-in">
        <div id="pageOverlay" className="overlay fade-in-delay1s"></div>
        <div className="logo-container fade-in-delay2s zoom-in-delay1s">
          <img src={logo} alt="Triton Appworks LLC" className="logo" aria-label="Triton Appworks LLC logo" />
        </div>

        <div className="button-container fade-in-delay3s zoom-in-delay2s">
          <button onClick={appsClick} className="button apps-filled apps-button" aria-description="Apps button takes you to the mobile and desktop apps page">Apps</button>
          <button onClick={utilitiesClick} className="button toolbox-regular utils-button" aria-description="Utilities button takes you to the web-based utilities page">Utilities</button>
          <button onClick={contactClick} className="button email-regular contact-button" aria-description="Contact button provides a popup form which you can use to contact us">Contact</button>
        </div>

        <MessageBox {...messageBoxProps} />

        <AppInsightsContext.Provider value={reactPlugin}>
          <PopupForm {...popupProps} />
        </AppInsightsContext.Provider>
        
        <footer className="footer fade-in-delay4s zoom-in-delay3s">
          &copy; {new Date().getFullYear()} Triton Appworks LLC
          <span className="padding-1">&#x2022;</span>
          <span className="square-peg-regular">Aloha from Hawaii!</span> &#x1F31E;
        </footer>
      </div>
    </div>
  );
}

export default App;
